import { graphql, useStaticQuery } from 'gatsby';

const queryCertificate = () => {
    const data = useStaticQuery(graphql`
        query GET_PORTAL_CERTIFICADOS_EMPRESAS {
            allContentfulTemplate(
                filter: {
                    titulo: {
                        eq: "Bloque de internas de certificados empresas"
                    }
                }
            ) {
                nodes {
                    titulo
                    estaActivo
                    serviceId
                    referencias {
                        ... on ContentfulTemplate {
                            metaInfo {
                                metaTitulo
                                metaDescripcion
                                metaImagen {
                                    file {
                                        url
                                    }
                                }
                                urlCanonical
                                noIndex
                            }
                            migaDePan
                            serviceId
                            nombre
                            descripcion {
                                raw
                            }
                            imagen {
                                title
                                file {
                                    url
                                }
                            }
                            referencias {
                                ... on ContentfulTemplate {
                                    nombre
                                    subtitulo
                                    tituloEnriquecido {
                                        raw
                                    }
                                    lista
                                    imagen {
                                        title
                                        file {
                                            url
                                        }
                                        gatsbyImageData(
                                            formats: [AUTO, WEBP]
                                            placeholder: BLURRED
                                        )
                                    }
                                    descripcion {
                                        raw
                                    }
                                    spanMagenta
                                    copyBoton
                                    redireccion
                                    type
                                }
                            }
                        }
                    }
                }
            }
        }
    `);
    return data.allContentfulTemplate.nodes[0];
};

export default queryCertificate;
